"use client";

import cnBind from "classnames/bind";

import { HOME_ENTITY_SUMMARY } from "@/shared/constants/homeStructuredData";

import styles from "./CompanyEntitySummary.module.scss";

const cx = cnBind.bind(styles);

/** In HTML for Google / AI crawlers; visually hidden from the UI. */
export function CompanyEntitySummary() {
    return (
        <section className={cx("seoOnly")} aria-hidden="true">
            <h2>{HOME_ENTITY_SUMMARY.heading}</h2>
            {HOME_ENTITY_SUMMARY.paragraphs.map((paragraph) => (
                <p key={paragraph.slice(0, 48)}>{paragraph}</p>
            ))}
        </section>
    );
}
